// extracted by mini-css-extract-plugin
export default {"navPagesContainer":"navPages_navPagesContainer__iGuG0","navPages":"navPages_navPages__1r-SC","button":"navPages_button__oW+0i"};